import {InventoryLocationInteraction, InventoryLocationInteractionFeatureType} from "./interaction";
import * as $ from "jquery";

export class InventoryLocationInteractionMulti extends InventoryLocationInteraction {
    /**
     * @type {jQuery|null}
     */
    list = null;

    constructor(name, handler, layer, options = {}) {
        options = {
            ...options,
            featureType: InventoryLocationInteractionFeatureType.MULTI
        }

        super(name, handler, layer, options);

        this.list = $(`[data-app-map_interaction_list="${this.name}"]`);
        if (!this.list.length) {
            this.list = null;
        }
    }

    addToList(feature, name) {
        if (!this.list) {
            return;
        }

        this.list.append(`
            <div data-app-map_interaction_element="${this.name}" data-app-feature_id="${feature.get('id')}" class="col-12">
                <label>${name}</label>
                <div class="row g-1">
                    <div class="col-4">
                        <button 
                            type="button"
                            data-app-map_interaction_edit_button="${this.name}" 
                            data-app-feature_id="${feature.get('id')}"
                            class="btn btn-primary w-100"
                        >
                            <i class="fas fa-pencil-alt"></i>
                        </button>
                    </div>
                    <div class="col-4">
                        <button 
                            type="button"
                            data-app-map_interaction_delete_button="${this.name}" 
                            data-app-feature_id="${feature.get('id')}"
                            class="btn btn-danger w-100"
                        >
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                </div>
                <div class="row mt-2 g-1">
                    <div class="col-12">
                        ${this.dictionary.measurementTitle ?? 'Pomiar'}: 
                        <span 
                            data-app-map_interaction_area="${this.name}" 
                            data-app-feature_id="${feature.get('id')}"
                        >
                            
                        </span>${this.dictionary.measurementUnit ?? 'ha'}
                    </div>
                </div>
            </div>
        `);
    }

    customCreateFeatureFromInput(type = 'Polygon', style = null, name = null) {
        super.createFeatureFromInput(type, style);

        let features = this.epLayer.getSource().getFeatures();

        let inputs = $(`[data-app-map_interaction_input="${this.name}"]`);
        let index = 1;
        for (let input of inputs) {
            let id = $(input).attr('data-app-feature_id');
            let feature = features.find(f => f.get('id') === id);

            if (feature) {
                this.addToList(feature, (name ? name : 'Obszar') + ' #' + index)
                index++;
            }
        }
    }

    onDelete(id) {
        super.onDelete(id);

        // remove list element
        $(`[data-app-map_interaction_element="${this.name}"][data-app-feature_id="${id}"]`).remove();

        // update labels
        $(`[data-app-map_interaction_element="${this.name}"] label`).each(function (index) {
            $(this).text(`Teren #${index + 1}`);
        })
    }
}